import { Icon } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent'

const InfoBanner = ({ data }) => {
  return (
    <div className='ew-px-16 ew-mt-16'>
      <CardComponent className='ew-bg-secondary'>
        <div className='ew-d-flex ew-gap-10 ew-align-items-start'>
          <Icon name='info' size={24} />
          <span className='ew-typography-small ew-fw-regular'>{data?.title}</span>
        </div>
      </CardComponent>
    </div>
  )
}

export default InfoBanner
